import $ from "jquery"
import {saveAIOutput} from "../Database/AnnotationsDAO"
import {db} from "../Database/handwaiDB.js"
//import {getToken} from "../Utils/Common"
import {getPositions} from "../Utils/helpers";
//import {updateProjectStatus} from "./analysenrequestdata";
//import {writeInitialData} from "./annotatorApi";

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
//let apilink = "http://0.0.0.0:60/"

// function createHighlightedString(ranges, text) {
//   var flatRanges = flattenRanges(ranges);
//   var inflatedRanges = inflateRanges(flatRanges, text.length);
//   var filledRanges = fillRanges(inflatedRanges, text);
//   //alert(JSON.stringify(flatRanges))
// 		//alert(JSON.stringify(inflatedRanges))
// 		//alert(JSON.stringify(filledRanges))
//   var str = "";
//   //var index = 0;
//   for (var i in filledRanges) {
//     var range = filledRanges[i];
//     //var begin = range.begin, end = range.end;
//     if (range.count > 0) {
//       if (range.tooltip) {
//         str += "<mark class='highlight-" + range.count + " tooltip'>" + range.text + "<span class='tooltiptext tooltip-bottom'>" + range.tooltip.join('<br/>') + "</span></mark>";
//       } else {
//         str += "<mark class='highlight-" + range.count + "'>" + range.text + "</mark>";
//       }
//     } else {
//       str += range.text;
//     }
//   }
//   return str;
// }
//
// function flattenRanges(ranges) {
//   var points = [];
//   var flattened = [];
//   for (var i in ranges) {
//     if (ranges[i].end < ranges[i].begin) { //RE-ORDER THIS ITEM (BEGIN/END)
//       var tmp = ranges[i].end+1; //RE-ORDER BY SWAPPING
//       ranges[i].end = ranges[i].begin;
//       ranges[i].begin = tmp;
//     }
//     points.push(ranges[i].begin);
//     points.push(ranges[i].end);
//   }
//   //MAKE SURE OUR LIST OF POINTS IS IN ORDER
//   points.sort(function(a, b){return a-b});
//   //FIND THE INTERSECTING SPANS FOR EACH PAIR OF POINTS (IF ANY)
//   //ALSO MERGE THE ATTRIBUTES OF EACH INTERSECTING SPAN, AND INCREASE THE COUNT FOR EACH INTERSECTION
//   for (var k in points) {
//     if (k==0 || points[k]==points[k-1]) continue;
//     var includedRanges = ranges.filter(function(x){
//       return (Math.max(x.begin,points[k-1]) < Math.min(x.end,points[k]));
//     });
//     if (includedRanges.length > 0) {
//       var flattenedRange = {
//         begin:points[k-1],
//         end:points[k],
//         count:0
//       }
//       for (var j in includedRanges) {
//         var includedRange = includedRanges[j];
//         for (var prop in includedRange) {
//           if (prop != 'begin' && prop != 'end') {
//             if (!flattenedRange[prop]) flattenedRange[prop] = [];
//             flattenedRange[prop].push(includedRange[prop]);
//           }
//         }
//         flattenedRange.count++;
//       }
//       flattened.push(flattenedRange);
//     }
//   }
//   return flattened;
// }
//
// function inflateRanges(ranges, length=0) {
//   var inflated = [];
//   var lastIndex;
//   for (var i in ranges) {
//     if (i==0) {
//       //IF THERE IS EMPTY TEXT IN THE BEGINNING, CREATE AN EMOTY RANGE
//       if (ranges[i].begin > 0){
//         inflated.push({
//           begin:0,
//           end:ranges[i].begin-1,
//           count:0
//         });
//       }
//       inflated.push(ranges[i]);
//     } else {
//       if (ranges[i].begin == ranges[i-1].end) {
//         ranges[i-1].end--;
//       }
//       if (ranges[i].begin - ranges[i-1].end > 1) {
//         inflated.push({
//           begin:ranges[i-1].end+1,
//           end:ranges[i].begin-1,
//           count:0
//         });
//       }
//       inflated.push(ranges[i]);
//     }
//     lastIndex = ranges[i].end;
//   }
//   //FOR SIMPLICITY, ADD ANY REMAINING TEXT AS AN EMPTY RANGE
//   if (lastIndex+1 < length-1) {
//     inflated.push({
//       begin:lastIndex+1,
//       end:length-1,
//       count:0
//     })
//   }
//   return inflated;
// }
//
// function fillRanges(ranges, text) {
//   for (var i in ranges) {
//     ranges[i].text = text.slice(ranges[i].begin,ranges[i].end+1);
//   }
//   return ranges;
// }
//
// /***
//  * Render ai results.
//  * AI predicted results are identified as purple highlights on UI
//  */
// export async function renderAIHighlights() {
//     const data = await db.ai.get({ unique_id: 'unique_id' });
//     if (data === undefined) {
//         // Check if the data didnt arrive yet to the frontend db
//         console.log('Pls, try later');
//         return;
//     }
//     const annotations = data.annotation_data;
//     // Write data in to the annotator database collection
//     //saveAllAIAnnotations(lvID, annotations)
//     //let list_mark_tags = [];
//     const lvDocument = data.lv_document;
//     console.log("lv-doc", lvDocument)
//     for (let position of lvDocument) {
//         if (position.id.length !== 0) {
//             let positionID = position.id;
//             if (document.getElementById(positionID) !== null) {
//                 let text_position = position.pText;
//                 if (annotations !== undefined && annotations !== [] && annotations[positionID] !== undefined) {
//                      //let rsl = tagAiAnnotations(annotations[positionID], text_position);
//                     let annots = annotations[positionID]
//                     let ranges = []
//                     for (let annot of annots){
// 						let position ={"begin": annot.position[0], "end": annot.position[1], "tooltip": annot.type}
// 						//alert(JSON.stringify(position))
// 						ranges.push(position)
//                     }
//                     // text_position = rsl[0];
//                     // let list_random_tags = rsl[1];
//                     // [text_position, list_mark_tags] = markAiAnnotations(
//                     //     list_random_tags,
//                     //     annotations[positionID],
//                     //     text_position,
//                     //     list_mark_tags
//                     // );
//
// 					//alert(JSON.stringify(ranges))
//
//
// 					let string = createHighlightedString(ranges, text_position)
// 					//alert(JSON.stringify(string))
// 					if (string) {
//
//                         document.getElementById(positionID.toString()).innerHTML = string
//                     }
//
//
//                 }
//                 //document.getElementById(positionID).innerHTML = text_position;
//             }
//         }
//     }
// 	//updateAnnotatorUI(list_mark_tags);
// }






/***
 * Updates the Annotation Form with respective data of an annotation.
 * @param list_mark_tags
 */
function updateAnnotatorUI(list_mark_tags) {
	for (let position of list_mark_tags) {
		let annotDataValue = position
		let annotationID = annotDataValue.unique_id
		let mark = document.getElementById(annotationID)
		if (mark !== null) {
			mark.innerHTML = mark.innerHTML.replace(/(\r\n|\n|\r)/gm, "")
		}
		if (mark !== null && mark !== undefined) {
			mark.addEventListener("click", function () {
				$("mark").removeClass("dashed-border-mark")
				$(this).addClass("dashed-border-mark")
				localStorage.setItem("annotationID", annotationID)
				$("#norm").val(annotDataValue.norm)
				$("#advice").val(annotDataValue.advice)
				$("#agl").val(annotDataValue.law)
				$("#kommentor").val(annotDataValue.kommentor)
				$("#category").val(annotDataValue.type)
				$("#formel").val(annotDataValue.formula)
				$("#ursache").val(annotDataValue.Annotation)
				// Hinweis has no value, so Calculation UI in Annotator UI needs to be read only
				// and default value set to zero.
				if (annotDataValue.type === "Hinweis") {
					$("#kalkulationValue")
						.val("Hinweis hat kein Wert!")
						.attr("readonly", true)
						.addClass("handwai-black-text")
						.removeClass("handwai-white-text")
					$("#kalkulationTotalValue").val("0")
				} else {
					$("#kalkulationValue")
						.val(annotDataValue.mengeUnitValue)
						.attr("readonly", false)
						.addClass("handwai-white-text")
						.removeClass("handwai-black-text")
					$("#kalkulationTotalValue").val(annotDataValue.value)
				}
			})
		}
	}
}

function wrapAnnotationWithMark(annotation, text, start, end) {
    const { norm, unique_id } = annotation;

    // Extract the original substring to wrap
    const originalSubstring = text.slice(start, end);

    // Create the <mark> tag
    const markedEntity = `<mark class="${norm}" data-descr="${norm}" id="${unique_id}">${originalSubstring}</mark>`;

    // Replace the annotated text with the marked entity
    const updatedText = text.slice(0, start) + markedEntity + text.slice(end);

    // Calculate the additional length introduced by wrapping
    const addedLength = markedEntity.length - originalSubstring.length;

    return { text: updatedText, addedLength };
}

function processAnnotationsForText(annotations, text) {
    // Sort annotations by start position to ensure proper processing order
    annotations.sort((a, b) => a.position[0] - b.position[0]);

    let updatedText = text;
    const listMarkTags = [];
    let offsetShift = 0;

    for (const annotation of annotations) {
        const [start, end] = annotation.position;

        // Adjust positions for current annotation
        const adjustedStart = start + offsetShift;
        const adjustedEnd = end + offsetShift;

        // Wrap the annotation in <mark> tags
        const { text: newText, addedLength } = wrapAnnotationWithMark(
            annotation,
            updatedText,
            adjustedStart,
            adjustedEnd
        );

        // Update the text and offset shift
        updatedText = newText;
        offsetShift += addedLength;

        // Track the annotation for UI updates
        listMarkTags.push(annotation);
    }

    return { updatedText, listMarkTags };
}

export async function renderAIHighlights() {
    const data = await db.ai.get({ unique_id: "unique_id" });
    if (!data) {
        console.log("Please try later");
        return;
    }

    const annotations = data.annotation_data;
    const lvDocument = data.lv_document;

    if (!annotations || annotations.length === 0 || !lvDocument) {
        console.log("No annotations or lvDocument found");
        return;
    }

    const listMarkTags = [];

    for (const position of lvDocument) {
        if (position.id.length === 0) continue;

        const positionElement = document.getElementById(position.id);
        if (!positionElement) continue;

        const textPosition = position.pText;

        const positionAnnotations = annotations[position.id];
        if (positionAnnotations && positionAnnotations.length > 0) {
            const { updatedText, listMarkTags: newMarkTags } = processAnnotationsForText(positionAnnotations, textPosition);

            // Update the text in the DOM
            positionElement.innerHTML = updatedText;

            // Append new tags to the global list
            listMarkTags.push(...newMarkTags);
        }
    }

    // Update UI with the marked annotations
    updateAnnotatorUI(listMarkTags);

    return annotations;
}

/***
 * Get Ai Annotations from the Backend and save into indexdb
 */
export async function getAiAnnotations(lvid) {
    let link = `${process.env.REACT_APP_BASE_URI}/aiannotations/` + lvid
    return fetch(link, {
        method: 'GET',
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            let annotation = JSON.parse(data.data);
            let lv_document = data.lv_document;
            saveAIOutput(annotation, lv_document);
            return annotation
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function getAllAnnotations(lvID){

    return fetch(`http://localhost:8008/v1/saas/annotator/get_annotations`, {
        method: 'POST',
        body: JSON.stringify({"lv_id": lvID})
    }).then(response => response.json())
        .then((data) => {
            let annotation = data.response;
            let lv_document = JSON.parse(getPositions());
            saveAIOutput(annotation, lv_document)
        })
        .catch((error) => {
            console.error('Error:', error);
        });

}
